import bb from 'blingblingjs';
import {show, hide} from './page-overlay'; 

const state = {
    isOpen: false
}

const trigger = bb('.js-fn__header-lang-select-trigger');
const langSelect   = bb('.currency-selector-wrapper')[0]



function open(){
    state.isOpen = true;
    update();
}


function close(){
    state.isOpen = false;
    update();
}

trigger.on('mouseenter', open);
trigger.on('mouseleave', close)



function update(){
    if(state.isOpen){
        show();
        langSelect.classList.add('--is-open');
    } else {
        hide()
        langSelect.classList.remove('--is-open');
    }
}